function formatState(state) {
  if (!state.id) {
    return $(`
      <div class="list-item">
        <div class="item-text">
          <span>${state.text}</span>
        </div>
      </div>
    `);
  }
  var $state = $(`
    <div data-id="${state.id}" class="listing-item">
      <div class="checkbox__element">
        <div class="d-flex w-100 col-gap-10px col-gap-lg-30px">
          <div class="checkbox-img">
            <img src="${state?.data?.images?.[0] || '/images/default_listing_image.png'}" alt="">
          </div>
          <div class="d-flex flex-column fs-9 fs-lg-8 justify-content-center gap-1 text-eclipse lh-140">
            <div class="font-RobotoMedium fs-8 string">${state.name}</div>
          </div>
        </div>
      </div>
    </div>
  `)
  return $state;
};

function cloneList(elem) {
  var selected_list = $(elem).next().find('.select2-selection__rendered').hide();
  var clone = selected_list.clone(true, true).show();
  if ($(elem).val() && $(elem).val().length) {
    clone.prepend(`      
      <li class="select2-selection__choice">
        <button type="button" class="select2-selection__choice__remove" tabindex="-1">
          <span aria-hidden="true">×</span>
        </button>
        <span class="select2-selection__choice__display">Clear All</span>
      </li>
    `)
    clone.find('.select2-selection__choice:first').on('click', function () {
      setTimeout(function () {
        $(elem).val([]).trigger('change')
      }, 0)
    })
  }
  clone.find('.select2-selection__choice').on('click', function () {
    var id = $(this).find('[data-id]').attr('data-id');
    setTimeout(function () {
      $(elem).val($(elem).val().filter(el => el != id)).trigger('change');
    }, 0)
  })
  $(elem).parent().find('.selected2').empty().append(clone)
}

global.modules.set({
  async init(context) {
    $('.select_listing, .select_listings', context).each(function () {
      var url = $(this).attr('url');
      $(this).select2({
        templateResult: formatState,
        templateSelection: function (data) {
          return $(`<span data-id=${data.id}>${data.name}</span>`);
        },
        dropdownParent: $(this).parent().find('.place-dropdown'),
        closeOnSelect: false,
        minimumInputLength: 3,
        multiple: true,
        ajax: {
          cache: true,
          delay: 300,
          context: $('.select2-results__option'),
          method: 'POST',
          url: url || '/search/listings',
          headers: {
            Accept: 'application/json'
          },
          processResults: function (data) {
            return {
              results: data.data.map(el => ({ ...el, id: String(el.id) }))
            };
          },
          data: function (params) {
            const data = new FormData($(this).closest('form')[0]);
            data.append('q', params.term);
            return data;
          }
        },
        "language": {
          noResults: function () {
            return $(`
                <div class="list-item">
                  <div class="item-text">
                    <span>No listings found</span>
                  </div>
                </div>
              `);
          },
          inputTooShort: function () {
            return $(`
              <div class="list-item">
                <div class="item-text">
                  <span>Type at least 3 characters</span>
                </div>
              </div>
            `);;
          }
        }
      }).on('change', function () {
        cloneList($(this));
      });
    })


    $('.select_listing, .select_listings', context).on('select2:open', function (e) {
      const evt = "scroll.select2";
      $(e.target).parents().off(evt);
      $(window).off(evt);
    });

    $('.select_listings').on('select2:close', () => {
      setTimeout(() => {
        $('.listings-select2').removeAttr('style')
      }, 100)
    });


    $('.select2-search').on('keydown', function (e) {
      if (e.which === 8 && !e.target.value.length) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    });

    $('.listings-select2').find('.select2-search__field').attr('placeholder', 'Select Listing');
    $('.select_listings').on("change", function (e) {
      $('.listings-select2').find('.select2-search__field').attr('placeholder', 'Select Listing');
    });
  }
})